import { render, staticRenderFns } from "./ModalMoveFields.vue?vue&type=template&id=15190d9c&scoped=true&lang=html&"
import script from "./ModalMoveFields.vue?vue&type=script&lang=js&"
export * from "./ModalMoveFields.vue?vue&type=script&lang=js&"
import style0 from "./ModalMoveFields.vue?vue&type=style&index=0&id=15190d9c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15190d9c",
  null
  
)

export default component.exports